module.exports = __webpack_public_path__ + "static/media/colorful-lollipops.8adfa405.jpeg";